import { useEffect, useRef } from 'react';

function useScroll(state) {
  const ref = useRef();

  useEffect(() => {
    ref.current &&
      ref.current.scrollTo({
        top: ref.current.scrollHeight,
        behavior: 'smooth',
      });
  }, [state]);

  return ref;
}

export default useScroll;
